import { useState, useEffect } from 'react';
import { ApplicationStatus } from 'handlers/application';

import { PrequalificationGetResponseType } from 'api/rtkQueryApi';
import { PreQualificationStep } from 'handlers/stages';
import { useNavigate } from 'react-router-dom';
import { env } from 'env';

const getStepByPreQualificationData = (data: PrequalificationGetResponseType['data']) => {
  const { status, account, offersData } = data;

  if (status === ApplicationStatus.OfferSelection) {
    return PreQualificationStep.Offers;
  }

  if (!offersData.onlineOffer?.available) {
    return PreQualificationStep.Offers;
  }

  if (status !== ApplicationStatus.CompletingVerification) {
    return null;
  }

  if (account.created && !account.verified) {
    return PreQualificationStep.EmailVerification;
  }

  if (!account.created) {
    return PreQualificationStep.CreateAccount;
  }

  if (!account.verified) {
    return PreQualificationStep.EmailVerification;
  }

  if (account.created && account.verified) {
    return PreQualificationStep.SignIn;
  }
  return null;
};

export const usePrequalificationStep = (preQualification: PrequalificationGetResponseType['data'] | undefined) => {
  const [preQualificationStep, setPreQualificationStep] = useState<PreQualificationStep | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (preQualification) {
      setPreQualificationStep(getStepByPreQualificationData(preQualification));
    }
  }, [preQualification]);

  useEffect(() => {
    if (preQualificationStep === PreQualificationStep.SignIn) {
      navigate(`${env.REACT_APP_BASE_URL}/login`);
    }
  }, [preQualificationStep]);

  return { preQualificationStep, setPreQualificationStep };
};
